import { Deserializable } from '../deserializable';
import { Tag } from '../general/tag';

export class UserSearchResult implements Deserializable {
  public id: number;
  public fullName: string;
  public email: string;
  public idNumber: string;
  public branch: string;
  public mobile: string;
  public active: boolean;
  public tags: Tag[] = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
